const SaveDataFile = (() => {
  const a = document.createElement("a");
  document.body.appendChild(a);
  // a.style = "display: none";
  return (data: any, fileName: string, dataType?: string) => {
    const blob = new Blob([data], { type: dataType || "octet/stream" });
    const url = window.URL.createObjectURL(blob);
    a.href = url;
    a.download = fileName;
    a.target = "_blank";
    a.click();
    window.URL.revokeObjectURL(url);
  };
})();

export {
  SaveDataFile
};
